import { ProjectCard } from "@/components/ProjectCard";
import { LinkInline, TypoInline, TypoP } from "@/components/ui/typography";
import { NextJs, TypeScript, TailwindCSS, PostgreSQL, RustDark, RustLight } from "developer-icons";
import { useTheme } from "@/providers/ThemeProvider";
import { ExternalLink } from "lucide-react";

export function Chess42Card(props: React.HTMLAttributes<HTMLDivElement>) {

    const { theme } = useTheme();

    const RustIcon = theme === "light" ? RustDark : RustLight;

    return (
        <ProjectCard
            {...props}
            className="w-full"
            title="42Chess"
            links={[{ label: "play", href: "https://42chess.fr", icon: ExternalLink }]}
            body={
                <TypoP className="text-sm">
                    Real-time <TypoInline className="text-accent font-medium">multiplayer chess</TypoInline> platform
                    for 42 students, live at <LinkInline href={"https://42chess.fr"} label={"42chess.fr"} className="font-semibold" />.
                    A <TypoInline className="text-accent font-medium">Next.js</TypoInline> front-end backed by an
                    authoritative <TypoInline className="text-accent font-medium">Rust</TypoInline> server built
                    on <LinkInline href={"https://github.com/tokio-rs/axum"} label={"axum"} className="font-semibold" />:
                    each live game runs in its own <TypoInline className="text-accent font-medium">tokio actor</TypoInline>,
                    validates moves with <LinkInline href={"https://github.com/niklasf/shakmaty"} label={"shakmaty"} className="font-semibold" /> and
                    streams events to players over <TypoInline className="text-accent font-medium">WebSockets</TypoInline>.
                </TypoP>
            }
            techStack={[NextJs, TypeScript, TailwindCSS, RustIcon, PostgreSQL]}
            infoList={[
                <>
                    Sign in with your <TypoInline className="text-accent font-medium">42 intra</TypoInline> account -{" "}
                    <LinkInline href={"https://www.better-auth.com"} label={"Better Auth"} className="font-semibold" /> issues
                    EdDSA JWTs, verified by the Rust server against its JWKS
                </>,
                <>
                    Full game flow: create / join, live games hub,{" "}
                    <TypoInline className="text-accent font-medium">resign</TypoInline>,{" "}
                    <TypoInline className="text-accent font-medium">draw offers</TypoInline>, auto-resync
                </>,
                <>
                    Wire protocol written once in Rust and exported to{" "}
                    <TypoInline className="text-accent font-medium">TypeScript</TypoInline> with{" "}
                    <LinkInline href={"https://github.com/Aleph-Alpha/ts-rs"} label={"ts-rs"} className="font-semibold" />
                </>,
                <>
                    <TypoInline className="text-accent font-medium">Next.js 16</TypoInline> + React 19 UI with Tailwind and shadcn,{" "}
                    <TypoInline className="text-accent font-medium">Drizzle</TypoInline> + PostgreSQL, local and online game modes
                </>,
            ]}
            imageUrl={undefined}
        />
    );
}
